module.exports = __webpack_public_path__ + "static/media/tiktok-white.43bac7b0.svg";